module.exports = "<div *ngIf=\"isLoaded\">\n  <app-dashboard-employee *ngIf=\"type == 'EMPLOYEE'\"></app-dashboard-employee>\n  <app-dashboard-client *ngIf=\"type == 'CLIENT'\" [data]=\"data\"></app-dashboard-client>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main